import {
  ApplicationConfig,
  ErrorHandler,
  importProvidersFrom,
  isDevMode,
  provideAppInitializer
} from '@angular/core';
import { provideServiceWorker } from '@angular/service-worker';
import { environment } from '@vaki/shared/util/environment';
import { CookieModule } from 'ngx-cookie';
import * as Sentry from '@sentry/angular';
import { GoogleTagManagerModule } from '../google-tag-manager';
import { wireErrorTrackingRuntime } from '../core/error-tracking/wire-error-tracking-runtime';

// Analytics initialization handled by ANALYTICS token (providedIn: 'root')
// with send_page_view: false. Manual page_view events are sent by Ga4Service
// to guarantee UTM campaign attribution in GA4 Traffic Acquisition.

export const browserConfig: ApplicationConfig = {
  providers: [
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000'
    }),
    importProvidersFrom(
      GoogleTagManagerModule.forRoot({
        id: environment.googleTagManager.id,
        gtm_auth: environment.googleTagManager.auth,
        gtm_preview: environment.googleTagManager.env
      }),
      CookieModule.withOptions({})
    ),
    // Drop-in replacement for Angular's default ErrorHandler — every
    // uncaught error the framework would otherwise only console.error
    // now also reaches Sentry.init()'s beforeSend (main.ts), which is a
    // true no-op whenever `environment.sentry.enabled` is false (see
    // sentry-browser.init.ts), so this provider is safe to register
    // unconditionally.
    { provide: ErrorHandler, useValue: Sentry.createErrorHandler() },
    // Remote Config-backed kill switch (AC8) and dynamic sample rate
    // (AC2) need Angular's injector, which doesn't exist yet at
    // main.ts's pre-bootstrap call to initErrorTrackingBrowser() — this
    // is the earliest point after that injector exists. Also tags events
    // with the internal user id (AC1). Browser-only by construction:
    // this whole provider list only merges into the browser bootstrap
    // (main.ts), never the server one.
    provideAppInitializer(() => wireErrorTrackingRuntime())
  ]
};
